// extracted by mini-css-extract-plugin
export default {"container":"expenses_settings_container__lD7Bz","colorDot":"expenses_settings_colorDot__rjp1U"};